import { SelectField, SelectFieldProps } from "@origin-digital/ods-core";
import React from "react";
import { FieldProps } from "formik";
import { getNestedValue } from "../helper";

type FormikSelectFieldProps = FieldProps & SelectFieldProps;

const FormikSelectField: React.FC<FormikSelectFieldProps> = ({
  field,
  form,
  ...props
}) => {
  const value = getNestedValue(form.values, field.name) as string;
  const error = getNestedValue(form.errors, field.name) as string;
  const helperText = getNestedValue(form.errors, field.name)?.toString();
  return (
    <SelectField
      {...props}
      {...field}
      variant="outlined"
      hideHelperTextSpace={true}
      displayEmpty={true}
      emptyAriaLabel="Empty"
      onChange={(event) => {
        form.setFieldValue(field.name, event.target.value);
      }}
      value={value}
      id={field.name}
      error={!!error}
      helperText={helperText}
    />
  );
};

export default FormikSelectField;
